import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'Fundamentos & Línea Herrero',
  result: 'Tu primera abertura fabricada sin errores'
}, {
  id: 2,
  title: 'Línea Módena',
  result: 'El estándar más vendido de Argentina dominado'
}, {
  id: 3,
  title: 'Línea A30 New & DVH',
  result: 'Acceso al mercado premium de máximos márgenes'
}, {
  id: 4,
  title: 'Cortes, Descuentos & Fórmulas',
  result: 'Cero perfiles quemados, sistema exacto'
}, {
  id: 5,
  title: 'Presupuestador Pro 2024',
  result: 'Cobrar bien aunque la inflación suba'
}, {
  id: 6,
  title: 'Instalación & Service',
  result: 'Entrega prolija que genera referidos'
}];
const includes = [{
  title: 'Fórmulas con medidas reales verificadas',
  detail: 'Descuentos para Herrero, Módena y A30'
}, {
  title: 'Checklist de fabricación paso a paso',
  detail: 'Para no saltearte ningún paso crítico'
}, {
  title: 'Control de calidad antes de entregar',
  detail: 'El protocolo anti-reclamos'
}, {
  title: 'Lista de materiales por trabajo',
  detail: 'Cuánto comprar, dónde y en qué orden'
}, {
  title: 'Protocolo de instalación profesional',
  detail: 'A plomo, a nivel, bien sellado'
}];
export function TomosSection() {
  return <section className="py-10 bg-gray-50" data-id="element-334">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-335">
        <div className="text-center mb-8" data-id="element-336">
          <h2 className="text-3xl md:text-4xl font-black text-matte mb-2" data-id="element-337">
            LOS 6 TOMOS
          </h2>
          <div className="w-16 h-1 bg-steel mx-auto" data-id="element-338"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-10" data-id="element-339">
          {tomos.map((tomo, index) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-white border-t-4 border-steel p-5 shadow-md" data-id="element-340">
              <div className="flex items-center mb-3" data-id="element-341">
                <Book className="w-6 h-6 text-steel mr-2" data-id="element-342" />
                <span className="text-xs font-bold text-silver uppercase tracking-wider" data-id="element-343">
                  Tomo {tomo.id}
                </span>
              </div>
              <h3 className="text-lg font-bold text-matte mb-2" data-id="element-344">
                {tomo.title}
              </h3>
              <p className="text-gray-600 text-sm font-medium border-t border-gray-100 pt-2" data-id="element-345">
                <span className="text-gold mr-1" data-id="element-346">→</span>
                {tomo.result}
              </p>
            </motion.div>)}
        </div>

        <div className="bg-white border border-gray-200 p-6 md:p-8 shadow-lg" data-id="element-347">
          <h3 className="text-xl md:text-2xl font-black text-matte mb-6 text-center" data-id="element-348">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-349">
            {includes.map((item, index) => <div key={index} className="flex items-start" data-id="element-350">
                <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-351" />
                <div data-id="element-352">
                  <h4 className="font-bold text-matte" data-id="element-353">{item.title}</h4>
                  <p className="text-gray-600 text-sm" data-id="element-354">{item.detail}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}